const PageTitle = (props: React.PropsWithChildren) => (
  <h1 className="text-2xl font-bold text-can-forest-teal" {...props} />
);

export { PageTitle };
